import React from "react";
import { Redirect } from "react-router-dom";

/** Legacy routes → unified Advisor page with voice mode. */
const AdvisorVoiceRedirect = () => <Redirect to="/console/advisor?voice=1" />;

export default AdvisorVoiceRedirect;
